<h2 mat-dialog-title>Add To Do Item</h2>

<mat-dialog-content fxLayout="column" [formGroup]="formGroup">

    <lgd-select class="selectPadding" controlName="entityType" label="Entity Type" placeholder="Select an Entity Type"
                [options]="entityTypesObservable">
    </lgd-select>

    <lgd-text *ngIf="isCustom" controlName="customEntity" label="Custom Item">
    </lgd-text>

    <lgd-typeahead *ngIf="!isCustom" controlName="entity" label="Entity" [options]="entitiesObservable"
                   (searchTextChanged)="lookupEntities($event)">
    </lgd-typeahead>

    <lgd-text controlName="note" label="To Do Note" telemetry="Edit-Note-ToDoItem-UtilityBilling">
    </lgd-text>

    <lgd-date-picker controlName="dueDate" label="Due Date" placeholder="Choose a Due Date"
                     telemetry="Edit-DueDate-ToDoItem-UtilityBilling">
    </lgd-date-picker>

    <mat-progress-bar [fxShow]="isSaving" mode="indeterminate"></mat-progress-bar>
</mat-dialog-content>

<mat-dialog-actions fxLayoutAlign="end start">
    <button mat-button color="primary" mat-dialog-close telemetry="Submission-Cancel-ToDoItem-UtilityBilling">
        Cancel
    </button>

    <button mat-button color="primary" (click)="add()" telemetry="Submission-Approve-ToDoItem-UtilityBilling">
        Add
    </button>
</mat-dialog-actions>